const API_HOST = process.env.REACT_APP_API_URL || '/api';

export function authHeaders() {
  const token = localStorage.getItem('neuro_access_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function authFetch(url, options = {}) {
  const headers = { ...authHeaders(), ...options.headers };
  return fetch(url, { ...options, headers });
}

export { API_HOST };
